import { useState, useEffect } from 'react';
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import './audit.css';
import { useMsal } from "@azure/msal-react";
import Alert from '@mui/material/Alert';
import mailData from "../Data/mailData.js";
import ArchivedAccordion from '../function-components/ArchivedAccordion.jsx';

export default function Audit() {
    const [file1, setFile1] = useState({ name: '' });
    const [file2, setFile2] = useState({ name: '' });
    const [file3, setFile3] = useState({ name: '' });

    const [documents, setDocuments] = useState([]);
    const [fileStatus, setFileStatus] = useState('');

    const [docError, setDocError] = useState(false);

    let sno1 = 0;
    let sno2 = 0;
    let sno3 = 0;
    let url = 'https://atci.lkm.qa.accenture.com/qa-apis/audit/doc';

    let downloadAccessIds = [
        "gajendra.mallik",
        "v.bheemarao.dani",
        "raghupathi.jalamane",
        "sridhar.aluri",
        "praveen.rajaram",
        "prabhakara.prabhu",
        "rahul.suresh.ghali",
        "vanitadevi.patil",
        "anirudh.a.goel",
        "anupama.nithyanand",
        "varsha.a.tyagi",
        "ankur.e.mishra",
        "arpita.m.singh"
    ]
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    let ipsLoggedInEnterpriseId = 'ankur.e.mishra';

    if (activeAccount?.idTokenClaims?.email) {
    ipsLoggedInEnterpriseId = activeAccount.idTokenClaims.email.split('@')[0];
}
    let downloadAccess = downloadAccessIds.includes(ipsLoggedInEnterpriseId)

    const getDocuments = () => {
        if (process.env.NODE_ENV === 'development') {
            url = 'http://localhost:3021/audit/doc';
        }
        axios.get(url,
            {
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'Authorization': localStorage.getItem("token"),
                    'Content-Type': 'application/json'

                }
            }
        )
            .then(res => {
                setDocuments(res.data.results);
            })
            .catch(err => {
                setDocError(true);
                console.log(err)
            });
    }

    const handleFileChange1 = (e) => {
        let selectedFile = e.target.files[0];
        selectedFile.name === undefined ? setFile1({ name: '' }) : setFile1(selectedFile);
    }

    const handleFileChange2 = (e) => {
        let selectedFile = e.target.files[0];
        selectedFile.name === undefined ? setFile2({ name: '' }) : setFile2(selectedFile);
    }

    const handleFileChange3 = (e) => {
        let selectedFile = e.target.files[0];
        selectedFile.name === undefined ? setFile3({ name: '' }) : setFile3(selectedFile);
    }

    const handleSubmit = (e, type) => {
        e.preventDefault();
        const formData = new FormData();

        if (file1.name !== '')
            formData.append('file', file1);
        else if (file2.name !== '')
            formData.append('file', file2);
        else if (file3.name !== '')
            formData.append('file', file3);

        formData.append('type', type);

        if (process.env.NODE_ENV === 'development') {
            url = 'http://localhost:3021/audit/doc';
            // alert(`you are not allowed to upload a file from development environment.`);
            // return;
        }

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
                'Authorization': localStorage.getItem("token"),
                // 'Content-Type': 'application/json'
            },
        };
        axios.post(
            url,
            formData,
            config
        )
            .then(res => {
                getDocuments();
                setFileStatus(res.data.message);
                setFile1({ name: '' });
                setFile2({ name: '' });
                setFile3({ name: '' });
                setTimeout(() => {
                    setFileStatus('');
                }, 2000)
            })
            .catch(err => console.log(err))
    }

    const handleDownload = (doc_id, doc_name) => {
        if (process.env.NODE_ENV === 'development')
            url = 'http://localhost:3021/audit/doc/';
        axios({
            method: 'get',
            url: `${url}/${doc_id}`,
            responseType: 'blob',
            headers: {
                'Authorization': localStorage.getItem("token"),
                'Content-Type': 'application/json'
            }

        })
            .then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    doc_name,
                );
                document.body.appendChild(link);
                link.click();
            })
            .catch(err => console.log(err))
    }

    useEffect(() => {
        getDocuments();
    }, [])

    return (
        <>
            <div className='audit'>
                <div className="audit-banner">
                    <img src={process.env.PUBLIC_URL + "/images/audit/audit-banner.png"} alt="Banner" />
                    <div className='audit-banner-text'>
                        <h1>Audits</h1>
                        {/* <h6>Lorem ipsum dolor sit, amet consectetur adipisicing amet consectetur.</h6> */}
                    </div>
                </div>
                <div className='audit-reports'>
                    <p className='audit-reports-title'>Auditing is part of the quality assurance function. It is used to compare actual conditions with requirements and to report those results to management. Audits are performed at different levels in an Organization. Capability Maturity Model Integration (CMMI) Audit is performed at L&TT organization level. The other Audits which L&TT Team undergoes pertain to are ISO 13485 Audit, ISO 20000 Audit and ISO 27001 Audit.</p>
                    {/* <p className='audit-reports-title'>Audit Reports</p>   */}

                    {docError && <Alert severity="error" className="errorAlert"><b>Internal Server Error:</b> Please try again with a hard refresh. If the issue persists, contact the LIS team for further assistance.</Alert>}

                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                            <Typography style={{ textAlign: 'left' }}>QA Internal Audit Checklist</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                <form onSubmit={(e) => handleSubmit(e, 'checklist')} className='audit-files-icon'>
                                    <input type="file" onChange={handleFileChange1} id="audit-file1" hidden />
                                    <label for="audit-file1" className='track-file-upload-label'>
                                        {file1.name !== '' ? file1.name : <div className='track-choose-file-content'>
                                            <img src={process.env.PUBLIC_URL + "/images/Track/upload.png"} alt="upload" />
                                            <span>Choose File</span>
                                        </div>}
                                    </label>
                                    {file1.name !== '' && fileStatus === '' && <button type="submit" className='track-file-upload-btn'>
                                        <img src={process.env.PUBLIC_URL + "/images/Track/upload.png"} alt="upload" />
                                        <span className='track-file-upload-btn-text'>Upload</span>
                                    </button>}
                                    {/* {fileStatus && <span className='track-upload-file-status'>{fileStatus}</span>}                                                                                                  */}
                                </form>
                                <p className='restricted-text'>Restricted for Track Leads and L&TT Leads</p>
                                <table className='audit-uploaded-checklist'>
                                    <thead>
                                        <tr>
                                            <th>SL.#</th>
                                            <th>Name</th>
                                            {downloadAccess && <th>Actions</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {documents.length !== 0 && documents.map((doc, index) => {
                                            if (doc.type === 'checklist' && doc.name !== "QA Internal Audit Checklist Ver 1.0.xlsx")
                                                return <tr>
                                                    <td>{++sno1}</td>
                                                    <td>{doc.name}</td>
                                                    {downloadAccess && <td className='audit-file-download' onClick={() => { handleDownload(doc.id, doc.name) }}>download</td>}
                                                </tr>
                                            return '';
                                        })}
                                        {documents.length === 0 && <tr><td colSpan="3" style={{ border: 'none' }}>No documents found.</td></tr>}
                                    </tbody>
                                </table>
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                            <Typography style={{ textAlign: 'left' }}>Internal Audit Reports</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                <form onSubmit={(e) => handleSubmit(e, 'internal')} className='audit-files-icon'>
                                    <input type="file" onChange={handleFileChange2} id="audit-file2" hidden />
                                    <label for="audit-file2" className='track-file-upload-label'>
                                        {file2.name !== '' ? file2.name : <div className='track-choose-file-content'>
                                            <img src={process.env.PUBLIC_URL + "/images/Track/upload.png"} alt="upload" />
                                            <span>Choose File</span>
                                        </div>}
                                    </label>
                                    {file2.name !== '' && fileStatus === '' && <button type="submit" className='track-file-upload-btn'>
                                        <img src={process.env.PUBLIC_URL + "/images/Track/upload.png"} alt="upload" />
                                        <span className='track-file-upload-btn-text'>Upload</span>
                                    </button>}
                                    {/* {fileStatus && <span className='track-upload-file-status'>{fileStatus}</span>}                                                                         */}
                                </form>
                                <p className='restricted-text'>Restricted for Track Leads and L&TT Leads</p>
                                <table className='audit-uploaded-checklist'>
                                    <thead>
                                        <tr>
                                            <th>SL.#</th>
                                            <th>Name</th>
                                            {downloadAccess && <th>Actions</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {documents.length !== 0 && documents.map((doc, index) => {
                                            if (doc.type === 'internal')
                                                return <tr>
                                                    <td>{++sno2}</td>
                                                    <td>{doc.name}</td>
                                                    {downloadAccess && <td className='audit-file-download' onClick={() => { handleDownload(doc.id, doc.name) }}>download</td>}
                                                </tr>
                                            return '';
                                        })}
                                        {documents.length === 0 && <tr><td colSpan="3" style={{ border: 'none' }}>No documents found.</td></tr>}
                                    </tbody>
                                </table>
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                            <Typography style={{ textAlign: 'left' }}>External Audit Reports</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                <form onSubmit={(e) => handleSubmit(e, 'external')} className='audit-files-icon'>
                                    <input type="file" onChange={handleFileChange3} id="audit-file3" hidden />
                                    <label for="audit-file3" className='track-file-upload-label'>
                                        {file3.name !== '' ? file3.name : <div className='track-choose-file-content'>
                                            <img src={process.env.PUBLIC_URL + "/images/Track/upload.png"} alt="upload" />
                                            <span>Choose File</span>
                                        </div>}
                                    </label>
                                    {file3.name !== '' && fileStatus === '' && <button type="submit" className='track-file-upload-btn'>
                                        <img src={process.env.PUBLIC_URL + "/images/Track/upload.png"} alt="upload" />
                                        <span className='track-file-upload-btn-text'>Upload</span>
                                    </button>}
                                    {/* {fileStatus && <span className='track-upload-file-status'>{fileStatus}</span>}                                                                             */}
                                </form>
                                <p className='restricted-text'>Restricted for Track Leads and L&TT Leads</p>
                                <table className='audit-uploaded-checklist'>
                                    <thead>
                                        <tr>
                                            <th>SL.#</th>
                                            <th>Name</th>
                                            {downloadAccess && <th>Actions</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {documents.length !== 0 && documents.map((doc, index) => {
                                            if (doc.type === 'external')
                                                return <tr>
                                                    <td>{++sno3}</td>
                                                    <td>{doc.name}</td>
                                                    {downloadAccess && <td className='audit-file-download' onClick={() => { handleDownload(doc.id, doc.name) }}>download</td>}
                                                </tr>
                                            return '';
                                        })}
                                        {documents.length === 0 && <tr><td colSpan="3" style={{ border: 'none' }}>No documents found.</td></tr>}
                                    </tbody>
                                </table>
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <ArchivedAccordion/>
                </div>
                <div className="icons-container">
                    <div className="icons-wrap">
                        <div className="icons-row row1">
                            <div className="icons-box">
                                <div className="img-link">
                                    <img src={process.env.PUBLIC_URL + "/images/Home/contact_icon.png"} alt="Mailicon" className="group-img mailIcon" id="icon-chat" />
                                    <a className="contact-us" target='_blank' href={`mailto: ${mailData.dellearningframework}`}><span className='menu-text'>Write to us</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='link_container_below'>
                <div className='link_cont_wrap'>
                    <div>
                        <img src={process.env.PUBLIC_URL + "/images/Home/Acc_GT_Dimensional_RGB.png"} alt="AccentureIcon" className='link_accenture_logo' />
                    </div>
                    <div className='link_text_cont'>
                        <span>For any queries or support, you may reach out to
                            <a className="link_anchor" href={`mailto:${mailData.qualityassurance}`} target="_blank"> {mailData.qualityassurance} </a></span>
                    </div>
                </div>
            </div>
        </>
    )
}